import React from "react";

const icons = {
  close_circle: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM11.4243 5.24001L10.76 4.57574L8 7.33574L5.24 4.57574L4.57574 5.24001L7.33574 8.00001L4.57574 10.76L5.24 11.4243L8 8.66427L10.76 11.4243L11.4243 10.76L8.66426 8.00001L11.4243 5.24001Z"
        fill="black"
      />
      <path
        d="M11.4242 5.23995L10.7599 4.57568L7.99995 7.33568L5.23995 4.57568L4.57568 5.23995L7.33568 7.99995L4.57568 10.7599L5.23995 11.4242L7.99995 8.66421L10.7599 11.4242L11.4242 10.7599L8.66421 7.99995L11.4242 5.23995Z"
        fill="white"
      />
    </svg>
  ),

  offers: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9201 8.78001L7.22007 1.07501C7.16971 1.02813 7.10385 1.00143 7.03507 1.00001H2.11007C1.96411 0.999349 1.81948 1.02761 1.68451 1.08316C1.54954 1.13871 1.42691 1.22044 1.3237 1.32365C1.2205 1.42685 1.13876 1.54948 1.08321 1.68445C1.02766 1.81942 0.999405 1.96406 1.00007 2.11001V7.03501C0.999275 7.06859 1.00554 7.10197 1.01846 7.13297C1.03138 7.16398 1.05067 7.19193 1.07507 7.21501L8.78007 14.94C8.82871 14.988 8.89427 15.0148 8.96257 15.0148C9.03086 15.0148 9.09642 14.988 9.14507 14.94L14.9201 9.14001C14.9677 9.09221 14.9944 9.02749 14.9944 8.96001C14.9944 8.89253 14.9677 8.82781 14.9201 8.78001ZM8.96507 14.375L1.50007 6.94001V2.11001C1.50004 2.0306 1.51591 1.95198 1.54675 1.8788C1.57758 1.80561 1.62276 1.73934 1.67961 1.68389C1.73646 1.62844 1.80383 1.58493 1.87776 1.55592C1.95169 1.52692 2.03068 1.51301 2.11007 1.51501H6.93007L14.3751 8.94001L8.96507 14.375ZM3.50007 2.48501C3.29384 2.48797 3.0931 2.5519 2.92313 2.66873C2.75316 2.78556 2.62156 2.95008 2.54492 3.14156C2.46827 3.33304 2.45 3.54292 2.4924 3.74476C2.53481 3.94661 2.636 4.13139 2.78322 4.27583C2.93045 4.42028 3.11712 4.51793 3.31974 4.55648C3.52235 4.59504 3.73184 4.57277 3.92183 4.49249C4.11181 4.41221 4.2738 4.27751 4.38737 4.10535C4.50094 3.93318 4.56103 3.73126 4.56007 3.52501C4.56009 3.38674 4.53254 3.24985 4.47903 3.12235C4.42552 2.99485 4.34712 2.8793 4.24842 2.78246C4.14972 2.68562 4.0327 2.60943 3.9042 2.55836C3.77571 2.50729 3.63831 2.48235 3.50007 2.48501ZM3.50007 4.05501C3.39618 4.05109 3.29575 4.0167 3.21126 3.95613C3.12677 3.89556 3.06196 3.81148 3.0249 3.71436C2.98783 3.61723 2.98015 3.51135 3.0028 3.4099C3.02546 3.30844 3.07745 3.21588 3.1523 3.14375C3.22716 3.07161 3.32158 3.02309 3.4238 3.0042C3.52603 2.98532 3.63155 2.99692 3.72724 3.03756C3.82293 3.07819 3.90455 3.14607 3.96195 3.23274C4.01935 3.31942 4.04999 3.42106 4.05007 3.52501C4.05083 3.59653 4.03697 3.66745 4.00934 3.73342C3.98171 3.79939 3.94089 3.85902 3.88939 3.90865C3.83789 3.95828 3.77679 3.99686 3.70984 4.02203C3.64289 4.0472 3.57151 4.05842 3.50007 4.05501Z"
        fill="black"
      />
    </svg>
  ),
};

export default function SupportingInfo({ icon, children }) {
  return (
    <div className="supporting-info ty-c2">
      {icons[icon]}
      {children}
    </div>
  );
}
